import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';

import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { ShortNamePipe } from './short-name.pipe';
import { FileSizePipe } from './file-size.pipe';

@NgModule({
  declarations:[FilterPipe, SearchPipe, ShortNamePipe, FileSizePipe],
  imports:[CommonModule],
  exports:[FilterPipe, SearchPipe, ShortNamePipe, FileSizePipe]
})

export class PipeModule{}
